class HCLDX {
    static baseURL() {
        let r = this.get_REACT_APP_HCL_DX_BASE_URL();
        let u = '';
        if (r !== undefined) {
            u = r;
            if (window.avnet && window.avnet.siteId) {
                u += window.avnet.siteId;
            }
        }
        return u;
    }

    static baseURLOfHCLDX() {
        return this.get_REACT_APP_HCL_DX_DOMAIN();
    }

    static get_REACT_APP_HCL_DX_BASE_URL() {
        // Temporary for Dev3 Dev1 FSP Application configured
        const hostname = window.location.href;
        if (hostname.includes('my.uat.avnet.com')) {
            return 'https://my.uat.avnet.com/';
        }
        return process.env.REACT_APP_HCL_DX_BASE_URL;
    }

    static get_REACT_APP_HCL_DX_DOMAIN() {
        const hostname = window.location.href;
        if (hostname.includes('my.uat.avnet.com')) {
            return 'https://my.uat.avnet.com';
        }
        return process.env.REACT_APP_HCL_DX_DOMAIN;
    }
}

export default HCLDX;